// extracted by mini-css-extract-plugin
export default {"page_title":"PresenterPage_page_title__8H+sL","page_content":"PresenterPage_page_content__Xwt0M"};